import { render, staticRenderFns } from "./type-cop.vue?vue&type=template&id=4d348375&scoped=true&"
import script from "./type-cop.vue?vue&type=script&lang=js&"
export * from "./type-cop.vue?vue&type=script&lang=js&"
import style0 from "./type-cop.vue?vue&type=style&index=0&id=4d348375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d348375",
  null
  
)

export default component.exports